var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 24,
    viewBox: "0 0 20.8 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29489",
    "data-name": "Group 29489",
    transform: "translate(-1.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40188",
    "data-name": "Path 40188",
    d: "M1.5,20.5a4,4,0,0,0,4,4H18.3a4,4,0,0,0,4-4V4.5a4,4,0,0,0-4-4H10.028A3.93,3.93,0,0,0,8.369.86a4.006,4.006,0,0,0-1.178.818L2.679,6.19a4.039,4.039,0,0,0-.817,1.173h0V7.37A3.948,3.948,0,0,0,1.5,9.028ZM18.3,2.1a2.4,2.4,0,0,1,2.4,2.4v16a2.4,2.4,0,0,1-2.4,2.4H5.5a2.4,2.4,0,0,1-2.4-2.4V9.028A2.422,2.422,0,0,1,3.159,8.5H7.1A2.4,2.4,0,0,0,9.5,6.1V2.159a2.416,2.416,0,0,1,.528-.059ZM7.9,3.231V6.1a.8.8,0,0,1-.8.8H4.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40189",
    "data-name": "Path 40189",
    d: "M9.867,10.5h-4.6a.767.767,0,0,0,0,1.533h4.6a.767.767,0,0,0,0-1.533Z",
    transform: "translate(1.889 6.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40190",
    "data-name": "Path 40190",
    d: "M4.5,8.267a.8.8,0,0,0,.829.767h9.943a.769.769,0,1,0,0-1.533H5.329A.8.8,0,0,0,4.5,8.267Z",
    transform: "translate(1.6 4.233)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProjectIcon);
export default __webpack_public_path__ + "static/media/uploadProject_Icon.ced74986277c3cd9f7b4445d51bdebd4.svg";
export { ForwardRef as ReactComponent };